/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Stack } from "@mui/material";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { AddLineWithIcon } from "components/add-line-with-icon";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { Fragment } from "react";
import { cloneObjectsArray } from "utils/array";
import { ComponentCardsItemContext } from "./component-cards-context";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";
// import { useTranslation } from "react-i18next";

const defaultItem = Object.freeze({
    image: "", // guid
    heading: "", // string
    date: "", // string
    description: "",
    link: "", // guid
    position: 0, // number
});

const ComponentCardsEditWrapper = (props) => {
    const { list: initialList = [], onChange, children } = props;

    if (typeof onChange !== "function") {
        throw Error("onChange was not supplied, or is not a function");
    }

    const { list, sortableMethods, controls } = useSortableComponentList(
        initialList,
        defaultItem,
        onChange
    );

    const { addNewItem, addNewItemBelow, removeItem, updateItems } = controls;

    const updateItemByPosition = (newItem, position) => {
        const imageArray = cloneObjectsArray(list);
        imageArray[position] = structuredClone(newItem);
        onChange(imageArray);
    };

    return (
        <Fragment>
            <div className="add-card-wrapper">
                <div className="add-card-label">Cards</div>
                <div className="add-card-cta-container" onClick={addNewItem}>
                    <div className="add-card-cta-icon">
                        <PlusRegularIcon />
                    </div>
                    <div className="add-card-cta-label">Add</div>
                </div>
            </div>
            <div className="simplicity-image-ImageList">
                <Stack direction="column">
                    {list &&
                        list.map((item, index) => {
                            const guid = item?.guid;
                            const ctx = {
                                index,
                                list,
                                onChange,
                                guid,
                                item,
                                position: index,
                                updateItemByPosition,
                                removeItem,
                            };

                            return (
                                <ComponentCardsItemContext.Provider
                                    key={`card-list-${guid}${index}`}
                                    value={ctx}
                                >
                                    <SortableContent
                                        id={guid}
                                        index={index}
                                        sortableMethods={sortableMethods}
                                    >
                                        {children}
                                        <div>
                                            <PositionButtons
                                                index={index}
                                                list={list}
                                                handleUpdate={updateItems}
                                            />
                                            <RemoveIcon
                                                className="simplicity-composer-field-editor-remove"
                                                onDeleteItem={removeItem}
                                                index={index}
                                            />
                                        </div>
                                    </SortableContent>

                                    <AddLineWithIcon addNewItem={() => addNewItemBelow(index)} />
                                </ComponentCardsItemContext.Provider>
                            );
                        })}
                </Stack>
            </div>
        </Fragment>
    );
};
export { ComponentCardsEditWrapper };
